import axios from 'axios';
import { TOKEN_KEY } from '../constants';

/* ── Base URL ──────────────────────────────────────────────
   Reads from .env:  REACT_APP_API_URL=https://deltadesk.in
   All endpoints already include /api (e.g. /api/auth/login)
   so baseURL = REACT_APP_API_URL + '/api'
─────────────────────────────────────────────────────────── */
const BASE_URL = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '') + '/api';

const client = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

/* ── Request interceptor — attach JWT token ── */
client.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

/* ── Response interceptor — auto logout on 401 ── */
client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem(TOKEN_KEY);
      /* redirect to login without full page reload loop */
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default client;